import script from "./SugestaoMelhoriaChatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SugestaoMelhoriaChatModal.vue?vue&type=script&setup=true&lang=js"

import "./SugestaoMelhoriaChatModal.vue?vue&type=style&index=0&id=5a45879e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a45879e"]])

export default __exports__